module.exports = __webpack_public_path__ + "static/media/glyph-team.ed5c6904.svg";